// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


// api
import * as commodity from '@/api/commodity.js'
import * as commodityCategory from '@/api/commodityCategory.js'
import * as commodityQuantityDetail from '@/api/commodityQuantityDetail.js'
import * as commoditySnapshot from '@/api/commoditySnapshot.js'
import * as customer from '@/api/customer.js'
import * as customerGroup from '@/api/customerGroup.js'
import * as dataDict from '@/api/dataDict.js'
import * as dataDictItem from '@/api/dataDictItem.js'
import * as enums from '@/api/enum.js'
import * as expRequest from '@/api/expRequest.js'
import * as fundAccount from '@/api/fundAccount.js'
import * as fundAccountDetail from '@/api/fundAccountDetail.js'
import * as purchaseOrder from '@/api/purchaseOrder.js'
import * as saleOrder from '@/api/saleOrder.js'
import * as smsRecord from '@/api/smsRecord.js'
import * as sysConfig from '@/api/sysConfig.js'
import * as sysMenu from '@/api/sysMenu.js'
import * as sysRole from '@/api/sysRole.js'
import * as tenant from '@/api/tenant.js'
import * as tenantPersonalConfig from '@/api/tenantPersonalConfig.js'
import * as user from '@/api/user.js'
import * as userPersonalConfig from '@/api/userPersonalConfig.js'
import * as versionRecord from '@/api/versionRecord.js'


Vue.prototype.$api = {
  ...commodity, ...commodityCategory, ...purchaseOrder, ...saleOrder, ...commodityQuantityDetail,
  ...commoditySnapshot, ...customer, ...dataDict, ...dataDictItem, ...enums,
  ...expRequest, ...fundAccount, ...fundAccountDetail, ...sysConfig, ...sysMenu,
  ...sysRole, ...tenantPersonalConfig, ...user, ...userPersonalConfig, ...versionRecord,
  ...smsRecord, ...tenant, ...customerGroup
}

//font
import './assets/font/iconfont.css';

// elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// // 修改 el-dialog 默认点击遮照为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.closeOnPressEscape.default = false
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

// echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

// vue-fragment
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

// 打印
import print from 'print-js'
Vue.prototype.$print = print;

// 时间处理
import moment from 'moment'
Vue.prototype.$moment = moment;

// xlsx解析文件
import * as XLSX from "xlsx";
Vue.prototype.$XLSX = XLSX;

// 环境变量
let envConfig = process.env;
Vue.prototype.$envConfig = envConfig;

// 自动引入处理组件插件
import componentsList from './utils/componentsRegister';
Vue.use(componentsList);

// json2Excel
import toExcel from './utils/excel'
Vue.prototype.$toExcel = toExcel

// rule
import * as ruleUtil from './utils/ruleUtil'
Vue.prototype.$ruleUtil = ruleUtil;

// storage
import * as storageUtil from './utils/storageUtil'
Vue.prototype.$storageUtil = storageUtil;

// jsTool
import * as jsTool from './utils/jsTool'
Vue.prototype.$jsTool = jsTool;

// 全局水印功能
import VueWatermark from 'vue-watermark';
Vue.use(VueWatermark);

// vuex
import store from './store/index'
Vue.prototype.$store = store;

// axios的finally
require("promise.prototype.finally").shim();

// hasPermi指令
Vue.directive('hasPermi', {
  inserted: function (el, binding, vnode) {
    const { value } = binding
    const all_permission = "*:*:*";
    const permissions = storageUtil.getPermissions();

    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value

      const hasPermissions = permissions.some(permission => {
        return all_permission === permission || permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
})

Vue.directive('fmtype', {
  // 当绑定了指令的这个HTML元素插入到父元素上时触发(在这里父元素是 `div#app`)**.但不保证,父元素已经插入了 DOM 文档.**
  inserted: function (el, binding, vnode) {
    const { value, expression } = binding;
    if (value) {
      el.style.color = Vue.prototype.$jsTool.getColor(value);
    }
  }
})



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js